import { render } from "./PendingInstituteActivationCard.vue?vue&type=template&id=2130fcab"
import script from "./PendingInstituteActivationCard.vue?vue&type=script&lang=js"
export * from "./PendingInstituteActivationCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PendingInstituteActivationCard.vue"]])

export default __exports__